import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';
import { styled } from '@mui/material/styles';

const WarningButton = styled(Button)(({ theme }) => ({
  color: theme.palette.error.main,
  borderColor: theme.palette.error.main,
  '&:hover': {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.contrastText,
    borderColor: theme.palette.error.main,
  },
}));

const DeleteConfirmDialog = ({ 
  open, 
  title = 'Löschen bestätigen', 
  content = 'Möchten Sie dieses Element wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
  confirmText = 'Löschen',
  cancelText = 'Abbrechen',
  onConfirm,
  onCancel
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      <DialogTitle id="delete-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-dialog-description">
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} autoFocus>
          {cancelText}
        </Button>
        <WarningButton onClick={onConfirm} variant="outlined">
          {confirmText}
        </WarningButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;